import React from 'react';
import { useSelector } from 'react-redux';
import refreshPageImg from 'src/assets/keep_refresh.png';
import { useAuth0 } from 'src/auth/useAuth0.hook';
import { RootState } from 'src/redux/config/rootReducer';
import { i18nService } from 'src/services/i18n.service';
import { graphQLRequest } from 'src/utils/graphQL/graphQLRequestModule';
import { logoutQuery } from 'src/utils/graphQL/queries/general/logoutQuery';
import { useGraphQLRequest } from 'src/utils/graphQL/useGraphQLRequest.hook';
import './StyledRefreshPage.css';

/**
 * RefreshPage is a React functional component that renders an error message
 * indicating that a user was not found.
 * Note: There is no hebrew translation since the user has not been found and no language is set.
 */
const RefreshPage: React.FC = () => {
  const { getTokenSilently, logout } = useAuth0();

  //get user from redux
  const user = useSelector((state: RootState) => state.user.user);

  //get client from useGraphQLRequest hook
  const { client } = useGraphQLRequest();

  /**
   *  Use the useGraphQLRequest hook to access the GraphQL client.
   */
  const handleLogout = async () => {
    // If the user is not authenticated, return.
    if (!user) {
      logout();
      return;
    }

    //get token and send logout request
    const token = await getTokenSilently(); //todo nir this will sometimes fail
    const query = logoutQuery;
    const res = await graphQLRequest(token, client, query);

    // If the request fails, log an error message and return.
    if (!res)
      console.error(`Failed to logout user: ${user.email} , with the following error: ${res}`);

    // try to log out even if the request fails
    //logout user via auth0
    logout && logout();
  };

  return (
    <div className="refresh-page-background-container">
      <div className="refresh-page-container">
        <div className="refresh-page-illustration">
          <img src={refreshPageImg} alt="User not found" />
        </div>
        <h1 className="refresh-page-title">{i18nService.translate('refresh.line1')}</h1>
        <p className="refresh-page-message">{i18nService.translate('refresh.line2')}</p>
        <p className="refresh-page-message">{i18nService.translate('refresh.line3')}</p>

        <button className="refresh-page-btn" onClick={() => handleLogout()}>
          {i18nService.translate('refresh.refreshBtn')}
        </button>
      </div>
    </div>
  );
};

export default RefreshPage;
